import { ApolloClient } from "apollo-client";
import { ApolloLink } from "apollo-link";
import { HttpLink } from "apollo-link-http";
import { onError } from "apollo-link-error";
import { withClientState } from "apollo-link-state";
import { getCSRFToken } from "@zendesk/knowledge-context";
import redirectToSignIn from "@zendesk/knowledge-utils/lib/redirectToSignIn";
import uuid from "uuid";
import resolvers from "./resolvers";
import defaultState from "state/defaults";
import introspectionQueryResultData from "./fragmentTypes.json";

import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from "apollo-cache-inmemory";

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

export const cache = new InMemoryCache({
  fragmentMatcher,
  // Since we use global ids which already contain type information
  // we can tell Apollo to use them as a key in store.
  dataIdFromObject: object => object.id || null,
  // Given that we request node per global id which is a store key
  // we can tell Apollo to try fetch node from store by id first.
  // e.g. GetByIdQuery can read from store after SearchByBrandQuery was run
  cacheRedirects: {
    Query: {
      node: (_, { id }, { getCacheKey }) => getCacheKey({ id }),
    },
  },
});

const stateLink = withClientState({
  cache,
  resolvers,
  defaults: defaultState,
});

const authLink = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      "X-Request-Id": uuid.v4(),
      "X-CSRF-Token": getCSRFToken(),
    },
  });

  return forward(operation);
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path, extensions }) => {
      if (extensions && extensions.code === "UNAUTHENTICATED") {
        redirectToSignIn();
      }
    });
  }
});

export default new ApolloClient({
  link: ApolloLink.from([
    stateLink,
    authLink,
    errorLink,
    new HttpLink({
      uri: "/guide/graphql",
      credentials: "include",
      headers: {
        "X-Client-Id": uuid.v4(),
      },
    }),
  ]),
  cache,
});



// WEBPACK FOOTER //
// ./src/apollo/client.js